module.exports = () => [
  {
    nr: '010',
    pattern: /^0(10)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0111',
    pattern: /^0(111)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0113',
    pattern: /^0(113)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0114',
    pattern: /^0(114)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0115',
    pattern: /^0(115)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0117',
    pattern: /^0(117)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0118',
    pattern: /^0(118)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '013',
    pattern: /^0(13)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '014',
    pattern: /^0(14)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '015',
    pattern: /^0(15)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0161',
    pattern: /^0(161)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0162',
    pattern: /^0(162)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0164',
    pattern: /^0(164)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0165',
    pattern: /^0(165)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0166',
    pattern: /^0(166)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0167',
    pattern: /^0(167)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0168',
    pattern: /^0(168)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0172',
    pattern: /^0(172)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0174',
    pattern: /^0(174)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0180',
    pattern: /^0(180)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0181',
    pattern: /^0(181)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0182',
    pattern: /^0(182)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0183',
    pattern: /^0(183)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0184',
    pattern: /^0(184)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0186',
    pattern: /^0(186)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0187',
    pattern: /^0(187)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '020',
    pattern: /^0(20)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0222',
    pattern: /^0(222)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0223',
    pattern: /^0(223)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0224',
    pattern: /^0(224)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0226',
    pattern: /^0(226)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0227',
    pattern: /^0(227)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0228',
    pattern: /^0(228)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0229',
    pattern: /^0(229)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '023',
    pattern: /^0(23)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '024',
    pattern: /^0(24)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0251',
    pattern: /^0(251)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0252',
    pattern: /^0(252)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0255',
    pattern: /^0(255)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '026',
    pattern: /^0(26)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0294',
    pattern: /^0(294)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0297',
    pattern: /^0(297)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0299',
    pattern: /^0(299)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '030',
    pattern: /^0(30)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0313',
    pattern: /^0(313)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0314',
    pattern: /^0(314)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0315',
    pattern: /^0(315)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0316',
    pattern: /^0(316)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0317',
    pattern: /^0(317)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0318',
    pattern: /^0(318)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0320',
    pattern: /^0(320)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0321',
    pattern: /^0(321)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '033',
    pattern: /^0(33)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0341',
    pattern: /^0(341)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0342',
    pattern: /^0(342)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0343',
    pattern: /^0(343)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0344',
    pattern: /^0(344)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0345',
    pattern: /^0(345)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0346',
    pattern: /^0(346)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0347',
    pattern: /^0(347)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0348',
    pattern: /^0(348)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '035',
    pattern: /^0(35)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '036',
    pattern: /^0(36)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '038',
    pattern: /^0(38)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '040',
    pattern: /^0(40)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0411',
    pattern: /^0(411)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0412',
    pattern: /^0(412)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0413',
    pattern: /^0(413)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0416',
    pattern: /^0(416)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0418',
    pattern: /^0(418)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '043',
    pattern: /^0(43)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '044',
    pattern: /^0(44)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '045',
    pattern: /^0(45)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '046',
    pattern: /^0(46)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0475',
    pattern: /^0(475)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0478',
    pattern: /^0(478)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0481',
    pattern: /^0(481)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0485',
    pattern: /^0(485)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0486',
    pattern: /^0(486)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0487',
    pattern: /^0(487)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0488',
    pattern: /^0(488)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0492',
    pattern: /^0(492)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0493',
    pattern: /^0(493)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0495',
    pattern: /^0(495)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0497',
    pattern: /^0(497)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0499',
    pattern: /^0(499)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '050',
    pattern: /^0(50)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0511',
    pattern: /^0(511)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0512',
    pattern: /^0(512)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0513',
    pattern: /^0(513)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0514',
    pattern: /^0(514)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0515',
    pattern: /^0(515)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0516',
    pattern: /^0(516)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0517',
    pattern: /^0(517)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0518',
    pattern: /^0(518)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0519',
    pattern: /^0(519)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0521',
    pattern: /^0(521)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0522',
    pattern: /^0(522)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0523',
    pattern: /^0(523)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0524',
    pattern: /^0(524)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0525',
    pattern: /^0(525)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0527',
    pattern: /^0(527)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0528',
    pattern: /^0(528)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0529',
    pattern: /^0(529)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '053',
    pattern: /^0(53)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0541',
    pattern: /^0(541)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0543',
    pattern: /^0(543)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0544',
    pattern: /^0(544)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0545',
    pattern: /^0(545)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0546',
    pattern: /^0(546)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0547',
    pattern: /^0(547)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0548',
    pattern: /^0(548)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '055',
    pattern: /^0(55)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0561',
    pattern: /^0(561)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0562',
    pattern: /^0(562)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0566',
    pattern: /^0(566)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0570',
    pattern: /^0(570)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0571',
    pattern: /^0(571)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0572',
    pattern: /^0(572)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0573',
    pattern: /^0(573)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0575',
    pattern: /^0(575)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0577',
    pattern: /^0(577)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0578',
    pattern: /^0(578)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '058',
    pattern: /^0(58)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0591',
    pattern: /^0(591)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0592',
    pattern: /^0(592)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0593',
    pattern: /^0(593)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0594',
    pattern: /^0(594)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0595',
    pattern: /^0(595)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0596',
    pattern: /^0(596)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0597',
    pattern: /^0(597)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0598',
    pattern: /^0(598)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '0599',
    pattern: /^0(599)([0-9]{0,6})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '070',
    pattern: /^0(70)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '071',
    pattern: /^0(71)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '072',
    pattern: /^0(72)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '073',
    pattern: /^0(73)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '074',
    pattern: /^0(74)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '075',
    pattern: /^0(75)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '076',
    pattern: /^0(76)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '077',
    pattern: /^0(77)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '078',
    pattern: /^0(78)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '079',
    pattern: /^0(79)([0-9]{0,7})([0-9]+)?$/,
    type: 'Vast telefoonnummer'
  },
  {
    nr: '027',
    pattern: /^0(27)([0-9]{0,7})([0-9]+)?$/,
    type: 'KPN Teletolk'
  },
  {
    nr: '0444',
    pattern: /^0(444)([0-9]{0,6})([0-9]+)?$/,
    type: 'Routering'
  },
  {
    nr: '061',
    pattern: /^0(61)([0-9]{0,7})([0-9]+)?$/,
    type: 'Mobiel'
  },
  {
    nr: '062',
    pattern: /^0(62)([0-9]{0,7})([0-9]+)?$/,
    type: 'Mobiel'
  },
  {
    nr: '063',
    pattern: /^0(63)([0-9]{0,7})([0-9]+)?$/,
    type: 'Mobiel'
  },
  {
    nr: '064',
    pattern: /^0(64)([0-9]{0,7})([0-9]+)?$/,
    type: 'Mobiel'
  },
  {
    nr: '065',
    pattern: /^0(65)([0-9]{0,7})([0-9]+)?$/,
    type: 'Mobiel'
  },
  {
    nr: '066',
    pattern: /^0(66)([0-9]{0,7})([0-9]+)?$/,
    type: 'Semafonie'
  },
  {
    nr: '0670',
    pattern: /^0(670)([0-9]{0,6})([0-9]+)?$/,
    type: 'Videotext'
  },
  {
    nr: '0671',
    pattern: /^0(671)([0-9]{0,6})([0-9]+)?$/,
    type: 'Videotext'
  },
  {
    nr: '0672',
    pattern: /^0(672)([0-9]{0,6})([0-9]+)?$/,
    type: 'Videotext'
  },
  {
    nr: '0673',
    pattern: /^0(673)([0-9]{0,6})([0-9]+)?$/,
    type: 'Videotext'
  },
  {
    nr: '0674',
    pattern: /^0(674)([0-9]{0,6})([0-9]+)?$/,
    type: 'Videotext'
  },
  {
    nr: '0675',
    pattern: /^0(675)([0-9]{0,6})([0-9]+)?$/,
    type: 'Videotext'
  },
  {
    nr: '0676',
    pattern: /^0(676)([0-9]{0,6})([0-9]+)?$/,
    type: 'Inbelnummer'
  },
  {
    nr: '0677',
    pattern: /^0(677)([0-9]{0,6})([0-9]+)?$/,
    type: 'Videotext'
  },
  {
    nr: '0678',
    pattern: /^0(678)([0-9]{0,6})([0-9]+)?$/,
    type: 'Videotext'
  },
  {
    nr: '0679',
    pattern: /^0(679)([0-9]{0,6})([0-9]+)?$/,
    type: 'Videotext'
  },
  {
    nr: '068',
    pattern: /^0(68)([0-9]{0,7})([0-9]+)?$/,
    type: 'Mobiel'
  },
  {
    nr: '069',
    pattern: /^0(69)([0-9]{0,7})([0-9]+)?$/,
    type: 'Mobiel'
  },
  {
    nr: '0800',
    pattern: /^0(800)([0-9]{0,7})([0-9]+)?$/,
    type: 'Informatienummer',
    length: [8, 11]
  },
  {
    nr: '082',
    pattern: /^0(82)([0-9]{0,7})([0-9]+)?$/,
    type: 'VPN'
  },
  {
    nr: '084',
    pattern: /^0(84)([0-9]{0,7})([0-9]+)?$/,
    type: 'Assistentie'
  },
  {
    nr: '087',
    pattern: /^0(87)([0-9]{0,7})([0-9]+)?$/,
    type: 'Assistentie'
  },
  {
    nr: '085',
    pattern: /^0(85)([0-9]{0,7})([0-9]+)?$/,
    type: 'Plaatsonafhankelijk netnummer'
  },
  {
    nr: '088',
    pattern: /^0(88)([0-9]{0,7})([0-9]+)?$/,
    type: 'Bedrijfsnummer'
  },
  {
    nr: '0900',
    pattern: /^0(900)([0-9]{0,7})([0-9]+)?$/,
    type: 'Betaald informatienummer',
    length: [8, 11]
  },
  {
    nr: '0906',
    pattern: /^0(906)([0-9]{0,7})([0-9]+)?$/,
    type: 'Betaald informatienummer'
  },
  {
    nr: '0909',
    pattern: /^0(909)([0-9]{0,7})([0-9]+)?$/,
    type: 'Betaald informatienummer'
  },
  {
    nr: '091',
    pattern: /^0(91)([0-9]{0,7})([0-9]+)?$/,
    type: 'Plaatsonafhankelijk netnummer'
  }
];
